import { gql } from '@apollo/client';

// SKU-page-local fragment. Intentionally NOT the shared ITEM_DIMENSIONS_FIELDS
// fragment (used by ShipmentForm / cache.js / onward-functions) — we add the
// `description` column and the `documents` relationship only for this page.
export const SKU_FIELDS = gql`
    fragment SkuFields on item_dimensions {
        item_dimension_id
        client_id
        sku
        description
        length
        width
        height
        cubes
        weight
        service_time
        item_type_details
        assembly_type
        rate_class
        inventory_min
        inventory_max
        serialized
        sellable
        created_at
        last_modified_at
        client {
            client_id
            business_name
        }
        documents {
            item_dimension_document_id
            name
            link
            file_type
        }
    }
`;

// `where` is built by useSkus — own client for regular users, or the whole org (via
// client.user.organization_id) for carrier admins, with the SKU search ANDed in.
export const QUERY_ITEM_SKU = gql`
    ${SKU_FIELDS}

    query SkuByScope(
        $where: item_dimensions_bool_exp!
        $limit: Int!
        $offset: Int!
        $order_by: [item_dimensions_order_by!]
    ) {
        results: item_dimensions(where: $where, limit: $limit, offset: $offset, order_by: $order_by) {
            ...SkuFields
        }
        aggregate: item_dimensions_aggregate(where: $where) {
            aggregate {
                count
            }
        }
    }
`;
